import { PropsWithChildren } from "react";
import { Colour } from "../../Variables";

export type CardProps = {
    title: string,
    headerTheme: Colour,
    headerClasses: string
}

export function CardSolid(props: PropsWithChildren<CardProps>) {
    return (
        <div className={`card card-solid-${props.headerTheme} shadow mt-4 ${props.headerClasses}`}>
            <div className="card-body">
                <div>
                    <h3>{props.title}</h3>
                    <hr className="ShortBlock" />
                </div>
                {props.children}
            </div>
        </div>
    );
}